/**
 * Consumer Profile Hooks
 *
 * Type-safe hooks for consumer profile management using tRPC.
 */

import {
  useConsumerNotificationSettings,
  useConsumerProfile,
  useUpdateConsumerNotificationSettings,
  useUpdateConsumerProfile,
} from '@/lib/trpc/hooks';

// Re-export types for backwards compatibility
export interface ConsumerProfile {
  id: string;
  email: string;
  name: string;
  phone?: string;
  status: string;
  profile?: Record<string, unknown>;
  emailVerified: boolean;
  createdAt: string | Date;
  updatedAt?: string;
}

export interface UpdateProfileInput {
  name?: string;
  phone?: string;
  profile?: Record<string, unknown>;
}

export interface NotificationSettings {
  email: boolean;
  push: boolean;
  sms: boolean;
}

// Export tRPC hooks with consumer-friendly names
export function useProfile() {
  return useConsumerProfile();
}

export function useUpdateProfile() {
  return useUpdateConsumerProfile();
}

// Notification settings now use tRPC
export function useNotificationSettings() {
  return useConsumerNotificationSettings();
}

export function useUpdateNotificationSettings() {
  return useUpdateConsumerNotificationSettings();
}

export default useProfile;
